const initial_state = {
  courseList: [],
  loading: false,
  addloading: false,
  deleteloading: false,
  error: null,
};

const courseListReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "GET_ALL_COURSE_LIST_REQUEST":
      return { ...state, loading: true };
    case "GET_ALL_COURSE_LIST_SUCCESS":
      return { ...state, courseList: action.payload, loading: false };
    case "GET_ALL_COURSE_LIST_FAIL":
      return { ...state, error: action.payload, loading: false };
    case "ADD_TO_COURSE_LIST_REQUEST":
      return { ...state, addloading: true };
    case "ADD_TO_COURSE_LIST_SUCCESS":
      return { ...state, addloading: false };
    case "ADD_TO_COURSE_LIST_FAIL":
      return { ...state, error: action.payload, addloading: false };
    case "DELETE_FROM_COURSE_LIST_REQUEST":
      return { ...state, deleteloading: true };
    case "DELETE_FROM_COURSE_LIST_SUCCESS":
      return { ...state, deleteloading: false };
    case "DELETE_FROM_COURSE_LIST_FAIL":
      return { ...state, error: action.payload, deleteloading: false };
    default:
        return {...state}
  }
};

export {courseListReducer}
